__turbopack_context__.v({
  "integrations-card-title": "aXT8la_integrations-card-title",
});
